import React from 'react';

import logoDark from '../assets/images/logo-dark.svg';

const DynamoLogo = () => {
  return <img src={logoDark} alt="Dynamo Logo" width="115px" />;
};

export default DynamoLogo;
